import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { SpinningButton } from "Components/ReactstrapSlim";
import { InputFL, ValidationSummary } from "Components/Inputs";
import { AccountClient, TwoFactorResponse } from "Services/LegacyAPI/AccountClient";
import { useApiClient } from "Services/API/useApiClient";

interface TwoFactorConfirmFormModel {
   AuthyToken: string,
}

const TwoFactorConfirmFormSchema: yup.SchemaOf<TwoFactorConfirmFormModel> = yup.object({
   AuthyToken: yup.string().required("Confrimation code is required").defined(),
}).defined();



export interface TwoFactorConfirmFormProps {
   isActive: boolean;
   email: string,
   lstoken: string,
   phoneNumberLast4: string,
   onSuccess: (logonResult: TwoFactorResponse) => boolean;
}

export const TwoFactorConfirmForm: React.FC<TwoFactorConfirmFormProps> = function ({ isActive, email, lstoken, phoneNumberLast4, onSuccess }) {
   const accountClient = useApiClient(AccountClient);
   const [isLoading, setIsLoading] = useState<boolean>(false);
   const [serverErrors, setServerErrors] = useState<Array<[string, string]>>([]);

   const formMethods = useForm<TwoFactorConfirmFormModel>({
      resolver: yupResolver(TwoFactorConfirmFormSchema),
      mode: "onBlur"
   });

   const onSubmit = async () => {
      if (isLoading)
         return;
      setIsLoading(true);
      setServerErrors([]);
      try {
         const isValid = await formMethods.trigger();
         if (isValid) {
            const formValues = formMethods.getValues();
            const twoFactorRegisterResult = await accountClient.twoFactorConfirm({
               ...formValues,
               UserName: email,
               LSToken: lstoken
            });
            if (twoFactorRegisterResult.success) {
               onSuccess(twoFactorRegisterResult);
            } else {
               setServerErrors([["email", twoFactorRegisterResult.error]]);
            }
         }
      } catch (err: any) {
         if (err.error) {
            setServerErrors([["email", err.error]]);
         }
         console.log(err);
      } finally {
         setIsLoading(false);
      }
   }

   const submitOnEnterHandler = (e: React.KeyboardEvent) => {
      if (e.key === "Enter") {
         onSubmit();
      }
   }

   useEffect(() => {
      if (isActive) {
         setTimeout(function () {
            formMethods.setFocus("AuthyToken");
         }, 500);
      }
   }, [isActive])

   return (
      <div className="signing-mode-inner">
         <div className="signing-header">
            Two factor authentication
         </div>
         <div className="signing-caption">
            We've sent you a confirmation code on your phone number ending with *{phoneNumberLast4}
         </div>
         <div className="signing-two-factor-form">
            <ValidationSummary errors={formMethods.formState.errors} serverErrors={serverErrors} className="text-center" />
            <InputFL control={formMethods.control} name="AuthyToken" placeholder="Confirmation code" className="stff-input" autoComplete="off" onKeyDown={submitOnEnterHandler} />
            <SpinningButton isLoading={isLoading} onClick={onSubmit} color="primary" size="md" fluid className="stff-cta">Confirm</SpinningButton>
         </div>
      </div>
   )
}